<template>
<div>
  <v-layout row justify-center>
      <!-- @click="getCurrentElement(investigador.id)" -->
    <v-dialog v-model="dialog" persistent max-width="450">
      <v-card>
        <!-- <v-card-title class="headline">localInv: {{this.investigador.titulo}} </v-card-title> -->

        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field v-model="nombre" label="Nombre completo*" required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="correo" label="Correo*" required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea v-model="comentarios" label="Comentarios*" required></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">Cerrar</v-btn>
          <v-btn color="green darken-1" flat="flat" @click="sendEmail()">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</div>
</template>

<script>
export default {
  name: 'investigadores-lineas-modal',
  data(){
    return{
      dialog: false,
      nombre: '',
      correo: '',
      comentarios: '',
      investigadorLocal: this.investigador
    }
  },
  methods:{
    sendEmail: function(){
      window.open(`mailto:admin.seicti@cocyted.mx?subject=Me interesa el proyecto ${this.investigador.titulo}&body=Nombre: ${this.nombre}, Correo: ${this.correo}, Mensaje: ${this.comentarios}`);
      this.nombre= '',
      this.correo= '',
      this.comentarios= '',
      this.dialog = false;
    }
  },
  props:{
    show: Boolean,
    investigadorId: Number,
    investigador: Object
  },
  watch:{
    show: function (value) {
      this.dialog = value
    },
    dialog: function (value) {
      this.$emit('update:show', value);
    }
  }
}
</script>